import { redirect } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { hasPermissionInList } from "@/features/navigation/filter-nav-entries";
import { PermissionAction, PermissionSubject } from "@complete-athlete/enums";

/** Selling needs this; the services tab does not, so a receptionist can read what is on offer. */
export const SELLS = { action: PermissionAction.MANAGE, subject: PermissionSubject.OFFER } as const;

/**
 * For the tabs that sell: anyone else lands on the services, which everyone can read. A route runs
 * this in the part of it that loads with every page, so it stays away from the page's own code.
 */
export const requireSelling = async () => {
  const { data } = await sdk.users.me.$get.send();
  if (!hasPermissionInList(data?.permissions ?? null, SELLS.action, SELLS.subject)) throw redirect({ to: "/offer" });
};
